import { colorSchemes } from "@constants/colorSchemes"

export const themeNameBySchemeCode = {
    [colorSchemes.dark]: "dark",
    [colorSchemes.light]: "light",
    [colorSchemes.default]: "system",
} as const
